<template>
  <svg class="svg-icon" :class="name" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('../../icons/svg', false, /\.svg$/)
requireAll(req)

export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    }
  }
}
</script>

<style>
.svg-icon {
  width: 16px;
  height: 16px;
  /* margin-top: -.2em; */
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
